import { styled } from "styled-components";

export const AccordionRoot = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;
